import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, FreeMode } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';


// ----------------------------------
// -------- SWIPER ------------------
// ----------------------------------


export function initSwiper() {


    // Obtener todos los thumbnails
    const thumbnails = document.querySelectorAll('.swiper-thumbnail');

    // Inicializar Swiper con autoplay, loop, freeMode, y navegación
    const swiperMain = new Swiper('.swiper--main', {
    modules: [Navigation, Pagination, Autoplay, FreeMode],
    spaceBetween: 20,
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next', 
        prevEl: '.swiper-button-prev',
    },
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    });

    // Función para thumbnail actual
    function updateCurrentThumbnail(currentIndex) {
            
        thumbnails.forEach((thumbnail) => {
            thumbnail.classList.remove('--current');
        });

        const currentThumbnail = document.querySelector(`.swiper-thumbnail[data-index="${currentIndex}"]`);
        if (currentThumbnail) {
            currentThumbnail.classList.add('--current');
        }
    }

    // Actualizar el thumbnail actual al cargar la página
    document.addEventListener('DOMContentLoaded', () => {
        // Actualiza el primer thumbnail cuando el DOM esté completamente cargado
        updateCurrentThumbnail(swiperMain.realIndex);
    });

    // Vincular los thumbnails con el slider principal
    thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', function () {
        const index = parseInt(this.getAttribute('data-index'));
        swiperMain.slideToLoop(index); // Mover el slider principal al índice correspondiente
        updateCurrentThumbnail(index); // Actualizar la clase --current en el thumbnail cuando se haga clic
    });
    });

    // Usar el evento slideChange para actualizar el thumbnail actual
    swiperMain.on('slideChange', () => {
        updateCurrentThumbnail(swiperMain.realIndex);
    });


}


